import { render, staticRenderFns } from "./ProfileChunkEditor.vue?vue&type=template&id=3077a40a&scoped=true&"
import script from "./ProfileChunkEditor.vue?vue&type=script&lang=js&"
export * from "./ProfileChunkEditor.vue?vue&type=script&lang=js&"
import style0 from "./ProfileChunkEditor.vue?vue&type=style&index=0&id=3077a40a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3077a40a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VCol,VRow,VToolbar})
